<template lang="pug">
  .height-100
    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(key="kpi_rrhh" v-if="perfilVacaciones === 'recursos humanos' && showKpiRRHH")
        component-dashboard-kpi
      .box.position-relative(key="kpi_jefe" v-if="perfilVacaciones !== 'usuario' && showKpiJefe")
        component-dashboard-kpi-jefe(@close="close('showKpiJefe')")
      .box.position-relative(key="kpi_usuario" v-if="showKpiUsuario")
        component-dashboard-kpi-usuario(@close="close('showKpiUsuario')")
    //- .margin-auto
      .half-width.margin-auto.margin-top-10
        h3.title Bienvenido al Self Service
        p
        p.subtitle.hide-break-1 Ingresa a las opciones del menú ubicado en el panel lateral izquierdo.
        p.subtitle.show-break-1 Ingresa a las opciones del menú ubicado en la parte inferior derecha.
</template>

<script>
import ComponentDashboardKPI from './Component_Dashboard_KPI'
import ComponentDashboardKPIJefe from './Component_Dashboard_KPI_jefe'
import ComponentDashboardKPIUsuario from './Component_Dashboard_KPI_usuario'
export default {
  name: 'login',
  data () {
    return {
      perfilVacaciones:localStorage.getItem('perfilVacaciones'),
      showKpiRRHH:true,
      showKpiJefe:true,
      showKpiUsuario:true
    }
  },
  components: {
    'component-dashboard-kpi':ComponentDashboardKPI,
    'component-dashboard-kpi-jefe':ComponentDashboardKPIJefe,
    'component-dashboard-kpi-usuario':ComponentDashboardKPIUsuario
  },
  methods: {
    close (componente) {
      this[componente] = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.show-break-1
  display:none
@media (max-width: 820px)
  .show-break-1
    display initial

  .hide-break-1
    display none
</style>



// WEBPACK FOOTER //
// Admin_View.vue?cc22bef8